import { ReactNode } from "react";

interface AlertProps {
  variant: "warning" | "highlight";
  children: ReactNode;
  showIcon?: boolean;
}

export default function Alert({
  variant,
  children,
  showIcon = variant === "warning",
}: AlertProps) {
  const variantClassName =
    variant === "warning"
      ? "bg-warning-muted text-warning-muted-text"
      : "bg-info-muted text-info";

  return (
    <div
      role="status"
      className={`w-full rounded-theme-medium px-4 py-3 text-sm leading-[1.4] ${variantClassName}`}
    >
      <div className="flex items-center gap-3">
        {showIcon && (
          <span
            aria-hidden="true"
            className="shrink-0 w-5 h-5 rounded-full border border-current flex items-center justify-center text-xs font-bold"
          >
            !
          </span>
        )}
        <p className="flex-1">{children}</p>
      </div>
    </div>
  );
}
